<template lang="pug">
#right-click-menu(
  ref='rightMenu',
  v-if='rightMenuVisible',
  @blur='closeRightClickMenu', :style='{ top:top, left:left }'
)
  p.right-click-menu-item(
    id="RightClickMediumBrowserMenu-editMediumButton",
    @click="rightClickMediaAction('editMedium', true)"
  )
    font-awesome-icon.icon(icon="edit")
    span &nbsp; {{ $t('Edit') }}
  p.right-click-menu-item(
    id="RightClickMediumBrowserMenu-copyTagsButton",
    :class="{ disabled: !(getMediumTags(mediumInFocus).length > 0) }"
    @click="rightClickMediaAction('copyTags', true)"
  )
    font-awesome-icon.icon(icon="copy")
    span &nbsp; {{ $t('Copy Tags') }}
  p.right-click-menu-item(
    id="RightClickMediumBrowserMenu-pasteTagsButton",
    v-if="$store.state.Clipboard.copied_media_tags.length > 0",
    @click="rightClickMediaAction('pasteTags', true)"
  )
    font-awesome-icon.icon(icon="paste")
    span &nbsp; {{ $t('Paste Tags') }}
  p.right-click-menu-item(
    v-if="mediumInFocus.type.indexOf('PlayList') > -1",
    id="RightClickMediumBrowserMenu-showPlaylistContentButton",
    @click="rightClickMediaAction('showPlayListContent', true)",
  )
    font-awesome-icon.icon(icon="film")
    span &nbsp; {{ $t('Load') }}
  p.right-click-menu-item(
    id="RightClickMediumBrowserMenu-showMediumUsageButton",
    @click="rightClickMediaAction('showMediumUsage', true)",
  )
    font-awesome-icon.icon(icon="broadcast-tower")
    span &nbsp; {{ $t('Medium usage') }}
  p.right-click-menu-parent(
    v-if="canReplaceMediumInPlaylist",
    id="RightClickMediumBrowserMenu-replaceMediumButton",
    @mouseover="displaySection = 'replace'",
    @mouseleave="displaySection = undefined",
    @click.stop=""
  )
    font-awesome-icon.icon(icon="exchange-alt")
    span &nbsp; {{ $t('Use as Replacement') }}
    font-awesome-icon.icon.float-right(icon="chevron-right")
    section.sub-menu.sub-menu-right(v-if="displaySection === 'replace'")
      p.right-click-menu-item(
        v-if="$store.state.Medium.media_selected_left[0].type.indexOf('PlayList') === -1",
        @click="rightClickMediaAction('replaceMedium', canReplaceMediumInPlaylist)",
      )
        font-awesome-icon.icon(icon="wifi")
        span &nbsp; {{ $t('in network ') }}
      p.right-click-menu-item(
        @click="rightClickMediaAction('replacePlayItem', canReplaceMediumInPlaylist)",
      )
        font-awesome-icon.icon(icon="film")
        span &nbsp; {{ $t('in playlist ') }}
  p.right-click-menu-item(
    id="RightClickMediumBrowserMenu-assignMediumButton",
    @click="rightClickMediaAction('assignMedia', assignTargetsSelectedRight)",
    :class="{ disabled: !assignTargetsSelectedRight }"
  )
    font-awesome-icon.icon(icon="link")
    span &nbsp; {{ $t(`Assign`) }}
    //- span &nbsp; {{ $t(`Assign medium to ${this.$store.state.Medium.media_selected_right[0].name}`) }}
  p.right-click-menu-parent(
    v-if="mediumInFocus.type.indexOf('PlayList') > -1 && this.$store.state.Medium.media_selected_left.length == 1",
    id="RightClickMediumBrowserMenu-replaceMediumButton",
    @mouseover="displaySection = 'clone-single'",
    @mouseleave="displaySection = undefined",
    @click.stop=""
  )
    font-awesome-icon.icon(icon="exchange-alt")
    span &nbsp; {{ $t('Clone') }}
    font-awesome-icon.icon.float-right(icon="chevron-right")
    section.sub-menu.sub-menu-right(v-if="displaySection === 'clone-single'")
      p.right-click-menu-item(
        id="RightClickMediumBrowserMenu-duplicatePlaylistButton",
        @click="rightClickMediaAction('duplicatePlaylist', true)",
      )
        font-awesome-icon.icon(icon="copy")
        span &nbsp; {{ $t('Clone simple') }}
      p.right-click-menu-item(
        id="RightClickMediumBrowserMenu-duplicatePlaylistRecursiveButton",
        @click="rightClickMediaAction('duplicatePlaylistRecursive', true)",
      )
        font-awesome-icon.icon(icon="copy")
        span &nbsp; {{ $t('Clone recursive') }}
  p.right-click-menu-item(
    id="RightClickMediumBrowserMenu-configureButton"
    v-if="mediumInFocus.type === 'PlayListExtended' || mediumInFocus.type === 'HTML5app'",
    @click="rightClickMediaAction('configure', true)",
  )
    font-awesome-icon.icon(icon="cogs")
    span &nbsp; {{ $t('Configure') }}
  p.right-click-menu-item(
    v-if="this.$store.state.Medium.media_selected_left.length === 1",
    id="RightClickMediumBrowserMenu-deleteMediaButton",
    @click="rightClickMediaAction('deleteMedia', true)",
  )
    font-awesome-icon.icon(icon="trash")
    span &nbsp; {{ $t('Delete') }}
  p.right-click-menu-parent(
    v-if="this.$store.state.Medium.media_selected_left.length > 1",
    id="RightClickMediumBrowserMenu-manymediaButton"
    @mouseover="displaySection = 'manymedia'",
    @mouseleave="displaySection = undefined",
    @click.stop=""
  )
    font-awesome-icon.icon(icon="object-ungroup")
    span &nbsp; {{ this.$store.state.Medium.media_selected_left.length }}&nbsp;{{ $t('selected media') }}
    font-awesome-icon.icon.float-right(icon="chevron-right")
    section.sub-menu.sub-menu-right(v-if="displaySection === 'manymedia'")
      p.right-click-menu-item(
          v-if='!someNonPlaylistMediaSelectedLeft'
          @click="rightClickMediaAction('duplicatePlaylists', true)",
          id="RightClickMediumBrowserMenu-cloneButton"
        )
          font-awesome-icon.icon(icon="copy")
          span &nbsp; {{ $t('Clone simple') }}
      p.right-click-menu-item(
          v-if='!someNonPlaylistMediaSelectedLeft'
          @click="rightClickMediaAction('duplicatePlaylistsRecoursive', true)",
          id="RightClickMediumBrowserMenu-cloneRecoursiveButton"
        )
          font-awesome-icon.icon(icon="copy")
          span &nbsp; {{ $t('Clone deep as group') }}
      p.right-click-menu-item(
        @click="rightClickMediaAction('createPlaylist', true)",
        id="RightClickMediumBrowserMenu-groupIntoPlaylistButton"
      )
        font-awesome-icon.icon(icon="film")
        span &nbsp; {{ $t('Group into playlist') }}
      p.right-click-menu-item(
        @click="rightClickMediaAction('createLayout', true)",
        id="RightClickMediumBrowserMenu-groupIntoLayoutButton"
      )
        font-awesome-icon.icon(icon="layer-group")
        span &nbsp; {{ $t('Group into layout') }}
      p.right-click-menu-item(
        v-if="assignTargetsSelectedRight",
        @click="rightClickMediaAction('assignMedia', assignTargetsSelectedRight)",
        id="RightClickMediumBrowserMenu-assignMediaButton"
      )
        font-awesome-icon.icon(icon="link")
        span &nbsp; {{ $t('Assign') }}
      p.right-click-menu-item(
        @click="rightClickMediaAction('deleteMedia', true)",
        id="RightClickMediumBrowserMenu-deleteMediaButton"
      )
        font-awesome-icon.icon(icon="trash")
        span &nbsp; {{ $t('Delete') }}
      p.right-click-menu-item(
        @click="rightClickMediaAction('replaceMediaByName', true)",
        id="RightClickMediumBrowserMenu-replaceByNameButton"
      )
        font-awesome-icon.icon(icon="exchange-alt")
        span &nbsp; {{ $t('Replace by name') }}
  .separator-line.light
  p.right-click-menu-item(
    id="RightClickMediumBrowserMenu-showPlaylogMediumButton",
    @click="rightClickMediaAction('showPlaylogMedium', true)",
    :class="{ disabled: mediumInFocus.type.indexOf('PlayList') > -1 }"
  )
    font-awesome-icon.icon(icon="bars")
    span &nbsp; {{ $t('Playlog') }}
  .admin-section(v-if='isAdminOrSuperAdmin')
    .menu-section(v-if='mediumInFocus.type.indexOf("Extended") > -1 || mediumInFocus.type === "HTML5app"')
      .separator-line.light
      p.right-click-menu-item(
        id="RightClickMediumBrowserMenu-upgradeExtensionButton",
        @click="rightClickMediaAction('upgradeExtension', true)"
      )
        font-awesome-icon.icon(icon="bars")
        span &nbsp; {{ $t('Upgrade Extension') }}
</template>

<script>
import Vue from 'vue'
import MediumIcon from '../Common/MediumIcon'
import mediaUtilsMixin from '../Common/mediaUtils.mixin'
import userUtilsMixin from '../Common/userUtils.mixin'

export default {
  props: ['libraryFolder'],
  mixins: [mediaUtilsMixin, userUtilsMixin],
  components: {
    MediumIcon
  },
  data () {
    return {
      errors: {
      },
      rightMenuVisible: false,
      top: '0px',
      left: '0px',
      mediumInFocus: undefined,
      displaySection: undefined
    }
  },
  methods: {
    async rightClickMediaAction (action, canDoIt) {
      if (!canDoIt) return
      if (action === 'copyTags') {
        const fullMedium = this.$store.state.Medium.media_list.find(medium => medium.id === this.mediumInFocus.id)
        this.$store.dispatch('Clipboard/setCopiedMediaTags', JSON.parse(JSON.stringify(fullMedium.MediumTags)))
      } else if (action === 'pasteTags') {
        await this.__pasteTags()
      } else if (action === 'duplicatePlaylistsRecoursive') {
        this.$emit('rightClickAction', { action, playlists: this.$store.state.Medium.media_selected_left })
      } else {
        this.$emit('rightClickAction', { action, medium: this.mediumInFocus })
      }
      this.closeRightClickMenu()
    },
    async __pasteTags () {
      this.$store.commit('Medium/SET_RELOADING_MEDIA', true)
      for (const selectedMedium of this.$store.state.Medium.media_selected_left) {
        const fullMedium = this.$store.state.Medium.media_list.find(medium => medium.id === selectedMedium.id)
        for (const mediumTag of this.$store.state.Clipboard.copied_media_tags) {
          await this.$store.dispatch('Medium/addMediumTagToMedium', [mediumTag.id, fullMedium.id])
        }
        await this.$store.dispatch('Medium/setMediaTags')
      }
      this.$store.commit('Medium/SET_RELOADING_MEDIA', false)
    },
    // RIGHT-CLICK
    setRightClickMenuPosition (top, left) {
      const largestHeight = window.innerHeight - this.$refs.rightMenu.offsetHeight - 25
      const largestWidth = window.innerWidth - this.$refs.rightMenu.offsetWidth - 25
      if (top > largestHeight) top = largestHeight
      if (left > largestWidth) left = largestWidth
      this.top = top + 'px'
      this.left = left + 'px'
    },
    closeRightClickMenu () {
      this.displaySection = undefined
      this.rightMenuVisible = false
    },
    async openRightClickMenu (medium, $event) {
      $event.preventDefault()
      this.$store.dispatch('Medium/setSelectedLibraryFolder', this.libraryFolder)
      await this.$store.dispatch('Medium/getMedium', { data: medium.id })
      if (
        !$event.ctrlKey &&
        !$event.metaKey &&
        this.$store.state.Medium.media_selected_left.findIndex(msl => msl.id === medium.id) === -1
      ) {
        this.$store.dispatch('Medium/clearMediaSelectedLeft')
        this.$store.dispatch('Medium/addMediumSelectedLeft', medium)
      } else {
        if (this.$store.state.Medium.media_selected_left.findIndex(msl => msl.id === medium.id) === -1) {
          this.$store.dispatch('Medium/addMediumSelectedLeft', medium)
        }
      }
      this.mediumInFocus = medium
      this.rightMenuVisible = true
      Vue.nextTick(() => {
        if (this.$refs.rightMenu) this.$refs.rightMenu.focus()
        this.setRightClickMenuPosition($event.y, $event.x)
      })
    },
    getMediumTags (medium) {
      const mediumInStore = this.$store.state.Medium.media_list.find(m => m.id === medium.id)
      if (!mediumInStore || !mediumInStore.MediumTags) return []
      return mediumInStore.MediumTags
    }
  },
  computed: {
    mediaTags () {
      return this.$store.state.Medium.media_tags
    },
    mediaFilterTagsLength () {
      return this.$store.state.Medium.media_filter[this.side].mediaTags.length
    }
  }
}
</script>
<style lang="scss">
@import "../../../theme-m4b/src/common/var.scss";
@import "../Common/rightClick.scss";
</style>



// WEBPACK FOOTER //
// src/components/Medium/RightClickMediumBrowserMenu.vue